import React from 'react'
import tutor from '../tutor image.svg'
import virtual from '../virtual.svg'
import connected from '../connected.svg'
import progress from '../learn.svg'
import '../styles/home.css'
import '../styles/global.css'
import LoginButton from './LoginButton'
import Footer from './Footer'
import video from '../video image.svg'
import RealTime from '../real time.svg'
import '../styles/header.css';

const LandingPage = () => {
    return (
      <>
    <div className="hero is-medium is-link">
        <div className="infoContainer">
			<div className="infoCol">
      <img src={progress} alt="logo"/>
			</div>
			<div className="infoCol">
				<div className="infoColText">
					<h2>Achieve your greatest potential.</h2>
					<p>
						We provide tools that help students connect with tutors.
					</p>
					<div className="centerSingleLine">
						<LoginButton styleOpt={true} text="Become a Tutor"/>
						<LoginButton styleOpt={false} text="Here to Learn"/>
					</div>
				</div>
			</div>
		</div>

    </div>

	<div className="hero is-medium is-light" style={{paddingBottom: '15%'}}>
		<div className="level-item">
			<h1 className="is-size-2">How it Works</h1>
		</div>
		<div className="level-item">
			<h2 className="is-size3-">Our platform helps connects learners and tutors alike</h2>
		</div>
		<div className="level-item">
		<img src={tutor} alt="logo" style={{width: '25%', height: '25%'}}/>
		<img src={connected} alt="logo" style={{width: '25%', height: '25%'}}/>
		<img src={virtual} alt="logo" style={{width: '25%', height: '25%'}}/>
		</div>
		
		<div className="level">
		<div className="level-left" style={{marginLeft: '10%', paddingRight: '5%'}}>
			<p>Learners contact tutors. <br/> Showing interest in <br/> education can go a long way <br/> especially when learning</p>
		</div>
		<div className="level-item" style={{marginRight: '4%'}}>
			<p>Contact tutors by using our directory.
			<br/>-We provide information such as <br/> email, location, and subjects taught
			</p>
		</div>
		<div className="level-right" style={{marginRight: '13%'}}>
			<p>Whether you choose to learn remotely  <br/> or meet with your tutor in person, <br/> we'll make sure you have a <br/> positive experience</p>
		</div>
		</div>
	</div>
	<h1 className="is-size-2" style={{textAlign: 'center'}}>Video Chat</h1>
	<div style={{textAlign: 'center'}}>
		Access to unlimited video chat minutes and members
	</div>
	<div style={{textAlign: 'center', paddingTop: '5%'}}>
		<img src={video} alt="logo" style={{width: '25%', height: '25%'}}/>
	</div>


    <div className="hero is-medium is-info">
        <div className="infoContainer">
			<div className="infoCol">
      <img src={RealTime} alt="logo"/>
			</div>
			<div className="infoCol">
				<div className="infoColText">
					<h2>We make advancing your education easier</h2>
					<p>
						Let's help you start
					</p>
					<div className="centerSingleLine">
						<LoginButton styleOpt={true} text="Become a Tutor"/>
						<LoginButton styleOpt={false} text="Here to Learn"/>					
					</div>
				</div>
			</div>
		</div>

    </div>
	<Footer/>

      </>
    )
}

export default LandingPage